import React from 'react';
import _ from 'lodash';
import {observer} from 'mobx-react';
import {Modal} from 'components/modals';
import UnlimitedPolicySummaryModalContent from './UnlimitedPolicySummaryModalContent';

const UnlimitedPolicySummaryModal = observer(({uiState}) => {
  const {policySummaryAccount, policy, employee} = uiState;
  if (!_.get(policySummaryAccount, 'timeOffType')) return null;

  return (
    <Modal isOpen={uiState.unlimitedPolicySummaryModalOpen} onHide={() => uiState.closePolicySummaryModals()} size='md'>
      <UnlimitedPolicySummaryModalContent
        timeOffTypeId={_.get(policySummaryAccount, 'timeOffType.id')}
        policy={policy}
        employee={employee}
        policySummaryAccount={policySummaryAccount}
      />
    </Modal>
  );
});

export default UnlimitedPolicySummaryModal;
